import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import UserForm from '../Form';
import { inviteUser } from '@resources/User/actions';
import { useIntl } from 'react-intl';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Create = (props) => {
	const { module, inviteUser, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return inviteUser(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.user.invite',
						defaultMessage:
							'A new User has been successfully invited',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.invite.user',
					defaultMessage: 'Invite User',
				})}
			</Title>
			<UserForm onSubmit={handleSubmit} {...props} module={module} />
		</Modal>
	);
};

const mapStateToProps = ({
	participants,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
}) => {
	return {
		participants,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
	};
};

export default connect(mapStateToProps, {
	inviteUser,
	fetchModulesBySubmoduleCode,
})(Create);
